/**
 * ******************************************************************************
 * Copyright Innov'ATM all rights reserved. This software is the property of
 * Innov'ATM and may not be used in any manner except under a license agreement
 * signed with Innov'ATM.
 * *******************************************************************************
 */

export const ganttPxPerMs = 0.00003; // how many px is a millisecond
export const ganttFlightBoxHeight = 60;
export const ganttFlightBoxMarginTop = 5;
export const ganttFlightRowMargin = 5;
export const ganttDayFormat = 'yyyy-MM-dd';
export const ganttDayPathFormat = 'dd-MM-yyyy';
export const ganttDefaultFromHour = 9;
//export const ganttNbTimelineHours = 24; //J 24h + J+1 4h
export const ganttOneMinuteInMilliSeconds = 60 * 1000;
